<script>
import Vue from "vue"
import VueDraggableResizable from "vue-draggable-resizable"
Vue.component("vue-draggable-resizable", VueDraggableResizable)

export default {
  props: {
    columns: Array,
    dataSource: Array,
    tableName: String,
  },
  data() {
    this.components = {
      header: {
        cell: this.resizeableTitle
      }
    };
    return {
      draggingState: {},
      resing: false,
      x: 0,
      m: 0
    };
  },
  computed: {
    arrsHeight(){
      let len = this.dataSource ? this.dataSource.length || 0 : 0
      // console.log((len + 1) * 100 + '%')
      return (len + 1) * 100 + '%'
    }
  },
  watch: {
    dataSource() {
      const draggingMap = {};
      this.columns.forEach(col => {
        const k = col.dataIndex || col.key
        draggingMap[k] = col.width
      });
      this.draggingState = Vue.observable(draggingMap)
    }
  },
  methods: {
    resizeableTitle(h, props, children) {
      let thDom = null;
      const { key, ...restProps } = props
      const {on,...noFunction} = restProps
      const filterKey = col => {
        const k = col.dataIndex || col.key
        return k === key
      };
      let col = this.columns.find(filterKey);
      let index = this.columns.findIndex(filterKey)
      if (!col || !col.width) {
        return <th {...restProps}>{children}</th>
      }
      if (col && col.slots) {
        return <th {...restProps}>{children}</th>
      }
      const onDrag = (x) => {
        this.resing = true
        this.draggingState[key] = 0
        if(x < 100){
          if(col.x){
            if(col.x > x){
              // 向左拖动
              col.x = Math.min((col.x || 0) , x)
              col.width = 100
            }else{
              // 向右拖动
              col.width = 100 + (x - (col.x || 0))
            }
          }else{
            col.x = Math.min((col.x || 0) , x)
            col.width = 100
          }
        }else{
          if(col.x){
            if(col.x > x){
              // 向左拖动
              col.x = Math.min((col.x || 0) , x)
              col.width = 100
            }else{
              // 向右拖动
              col.width = 100 + (x - (col.x || 0))
            }
          }else{
            col.width = x
          }
        }
      }

      const onDragstop = () => {
        let columns = [...this.columns]
        columns.splice(index, 1, col)
        this.draggingState[key] = thDom.getBoundingClientRect().width
        this.tableName && window.localStorage.setItem(this.tableName, JSON.stringify(columns.map(i=>{
          const {width,key,dataIndex} = i
          return {width,key:dataIndex || key}
        })))
        noFunction.on = {...on}
        setTimeout(() => {
          if(col.width > 100) delete col.x
          this.resing = false
        },200)
        return false
      }
      let newRestProps = this.resing ? noFunction : restProps
      return (
        <th
          {...newRestProps}
          v-ant-ref={r => (thDom = r)}
          width={col.width}
          class="resize-table-th"
        >
          {children}
          {/**style={{height: this.arrsHeight}}*/}
          <div class="arrs">
            <vue-draggable-resizable
              key={col.dataIndex || col.key}
              class="table-draggable-handle"
              w={10}
              x={this.draggingState[key] || col.width}
              z={1}
              axis="x"
              draggable={true}
              resizable={false}
              onDragging={onDrag}
              onDragstop={onDragstop}
            />
          </div>
        </th>
      );
    }
  },
  render() {
    const on = {
      ...this.$listeners
    };
    const props = {
      ...this.$attrs,
      ...this.$props,
      ...{
        dataSource: this.dataSource,
        columns: this.columns
      }
    };
    const slots = Object.keys(this.$slots).map(slot => {
      return <template slot={slot}>{this.$slots[slot]}</template>;
    });
    return (
      <a-table
        bordered
        props={props}
        components={this.components}
        scopedSlots={this.$scopedSlots}
        on={on}
      >
        {slots}
      </a-table>
    );
  }
};
</script>

<style lang="scss">
.resize-table-th {
  position: relative;
  z-index: 1000000;
}
.table-draggable-handle {
  height: 100% !important;
  bottom: 0;
  left: auto !important;
  right: -10px;
  cursor: col-resize;
  touch-action: none;
  position: absolute;
  z-index: 1000000;
}
.resize-table-th .inner {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000000;
}
.resize-table-th {
  position: relative;
  z-index: 1000000;
}
.resize-table-th .table-draggable-handle {
  transform: none !important;
  position: absolute;
  cursor: col-resize;
  touch-action: none;
  position: absolute;
  left:0;
  right:0;
  top:0;
  bottom:0;
  z-index: 1000000;
}
.arrs{
  position: absolute;
  bottom: 0;
  right: 0px;
  width: 10px;
  top:0;
  cursor: col-resize;
  // height: 500%;
  // background: red;
  // z-index: 1000000;
}
// td.ant-table-column-has-actions{
//   position: relative;
//   &:after{
//     content: '';
//     display: block;
//     position: absolute;
//     width: 10px;
//     height: 100%;
//     background: blue;
//     cursor: col-resize;
//     right: 0;
//     top: 0;
//     bottom: -100px;
//   }
// }
</style>
